export async function loadVersion(
  versionPath: string
): Promise<string | undefined> {
  const response = await fetch(versionPath);
  if (!response.ok) {
    return undefined;
  }
  const version = (await response.text()).trim();
  if (version.startsWith("<!doctype html>")) {
    return undefined;
  }
  if (version === "" || version.includes("\n")) {
    return undefined;
  }
  return version;
}
